import {
  Component,
  OnInit,
  ElementRef,
  Input,
  ViewChild
} from "@angular/core";
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from "../../services/data.service";
export interface ConfirmModel3 {
  title: string;
  message: string;
}


@Component({
  selector: 'app-rest-item-search',
  templateUrl: './rest-item-search.component.html',
  styleUrls: ['./rest-item-search.component.css']
})
export class RestItemSearchComponent extends DialogComponent<ConfirmModel3, boolean>
  implements ConfirmModel3, OnInit {
  title: string;
  message: string;
  loading: boolean = false;
  result: any = { item: [], result: false };;
  rtnData: any;
  selectedRow: number = -1;
  sliceStrat: number = 0;
  sliceEnd: number = 15;
  Unit: string = "";
  f: any = {
    Name: "",
    Barcode: "",
    ShortName: "",
    CategoryName: "",
    SellingPrice: "",
    CostPrice: "",
    PrinterName: ""
  };
  private el: ElementRef;
  @Input() onReturn: string;
  @ViewChild('DCode') DCode: ElementRef;
  @ViewChild('DName') DName: ElementRef;
  constructor(dialogService: DialogService, private ds: DataService) {
    super(dialogService);
    this.fullData = ds.RestItemDetails;
  }
  fullData: any;

  ngOnInit() {
    this.DCode.nativeElement.focus();
    //document.getElementById("focus").focus();
    //document.getElementById("ItemCode").focus();
    // this.ds.loadRestItems();
    if (!this.fullData) {
      this.close();
    } else {

      this.fullData = this.ds.RestItemDetails;
      this.loading = true;
    }
  }

  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  setClickedRow(e) {
    this.selectedRow = e;
    document.getElementById("focus").focus();
  }
  NextBut() {
    if (!this.NexbutEnable()) {
      this.fullData = this.ds.RestItemDetails;
      this.sliceEnd = Number(this.sliceEnd) + 15
      this.selectedRow = 0
    }
  }
  PreBut() {
    if (!this.PrebutEnable()) {
      this.fullData = this.ds.RestItemDetails;
      this.sliceEnd = Number(this.sliceEnd) - 15
      this.selectedRow = 0
    }
  }
  NexbutEnable(): boolean {

    return this.fullData.total < this.sliceEnd
  }
  PrebutEnable(): boolean {
    return this.sliceEnd < 16
  }
  ItesmSearch(e, type) {
    if (e.keyCode == 13 && e.which == 13) {
      this.fullData = this.ds.RestItemDetails;
      switch (type) {
        case "Barcode":
          this.f.Barcode = e.target.value;
          break;
        case "Name":
          this.f.Name = e.target.value;
          break;
        case "ShortName":
          this.f.ShortName = e.target.value;
          break;
        case "CategoryName":
          this.f.CategoryName = e.target.value;
          break;
        case "SellingPrice":
          this.f.SellingPrice = e.target.value;
          break;
        case "CostPrice":
          this.f.CostPrice = e.target.value;
          break;
        case "PrinterName":
          this.f.PrinterName = e.target.value;
          break;
      }
      this.selectedRow = 0;
    } else if (e.keyCode == 40 && e.which == 40) {
      document.getElementById("focus").focus();
      this.selectedRow = 0;
    }
  }
  scroll(event: KeyboardEvent) {
    //up 38 down 40
    event.preventDefault();
    if (event.keyCode === 40) {
      if (this.selectedRow > 13) {
        this.NextBut();
      } else {
        this.selectedRow++;
      }
    } else if (event.keyCode === 38) {
      if (this.selectedRow < 1) {
        this.PreBut();
      } else {
        this.selectedRow--;
      }
    } else if (event.keyCode === 13) {
      this.selecedItem();
    }
    else return;
  }
  selecedItem() {
    var abc = document.getElementsByClassName("selectedItesmsaerch786")[0].getElementsByClassName("bkd")[0].innerHTML;
    var bcd = this.fullData.data.find(x => x.Barcode == abc);
    this.confirm(bcd);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/rest-item-search/rest-item-search.component.ts